import { useCallback, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { Settings } from 'luxon';

const useDefaultTimezone = (timezone?: string, shouldRevert = true) => {
    const queryClient = useQueryClient();
    const { timezone: accountTimezone } = useCurrentAccount();
    const [didInit, setDidInit] = useState(false);

    const setTimezone = useCallback(
        (tz?: string | null) => {
            Settings.defaultZone = tz ?? accountTimezone ?? 'local';
        },
        [accountTimezone],
    );

    useEffect(() => {
        if (!didInit) {
            setTimezone(timezone);
            setDidInit(true);
        }
    }, [didInit, setTimezone, timezone]);

    useEffect(() => {
        return () => {
            if (shouldRevert) {
                setTimezone(accountTimezone);
            }
        };
    }, [shouldRevert, accountTimezone, queryClient, timezone, setTimezone]);

    return { didInit, setTimezone };
};

export { useDefaultTimezone };
